import { Fragment } from "react";
import ReactECharts from "echarts-for-react";
import { useChartParam, Parameter } from "Components/Report/OnDemand/charts/shared/utils";
import ChartCard from "Components/Report/OnDemand/charts/shared/ChartCard";
import { getConfig } from "Components/Report/OnDemand/charts/shared/config";
import { ReportDeviceStatus, ReportAccountStatus } from "Utility/Types/report";
import { hoverFormat } from "./shared/utils";
import moment from "moment";

interface T {
  lte_tx: number[];
  lte_rx: number[];
  lte_rssi: number[];
  lte_rsrp: number[];
  wan_tx: number[];
  wan_rx: number[];
}

const UsageBarLine = ({
  param,
  id = "",
  data,
  isFetching,
  name,
}: {
  param: Parameter;
  id?: string;
  data?: ReportDeviceStatus[] | ReportAccountStatus[];
  isFetching: boolean;
  name?: string;
}) => {
  const { title, Ymax, Y2max, Xaxis, Xunit, isDarkMode } = useChartParam(param, id, data, name);

  const isCellular = param === "device_celluar_usage";
  const dataTilNow: any = [];
  data?.map((item: any) => {
    if (item.start_utc < moment.utc().valueOf() / 1000) {
      dataTilNow.push(item);
    } else {
      return;
    }
  });
  const seriesData = (dataTilNow as (ReportDeviceStatus & ReportAccountStatus)[])?.reduce<T>(
    (a, b) => {
      return {
        ...a,
        lte_tx: [...a.lte_tx, b?.interface?.lte?.tx_kbytes],

        lte_rx: [...a.lte_rx, b?.interface?.lte?.rx_kbytes],

        lte_rssi: [...a.lte_rssi, b?.interface?.lte?.rssi],
        lte_rsrp: [...a.lte_rsrp, b?.interface?.lte?.rsrp],

        wan_tx: [...a.wan_tx, b?.interface?.wan?.tx_kbytes],

        wan_rx: [...a.wan_rx, b?.interface?.wan?.rx_kbytes],
      };
    },
    {
      lte_tx: [],
      lte_rx: [],
      lte_rssi: [],
      lte_rsrp: [],
      wan_tx: [],
      wan_rx: [],
    }
  );

  const props = {
    legend: {
      selected: { RSRP: false },
    },
  };
  let config = getConfig({
    isDarkMode,
    tooltip: {
      trigger: "axis",
      formatter: function (params) {
        return hoverFormat(params, data);
      },
    },
    xAxis: [
      {
        data: Xaxis,
        name: Xunit,
        axisLabel: {
          color: isDarkMode ? "white" : "gray",
        },
      },
    ],
    yAxis: [
      {
        name: "kbytes",
        max: Ymax || null,
        axisLabel: {
          color: isDarkMode ? "white" : "gray",
        },
      },
      // {
      //   name: "dBm",
      //   max: Y2max || null,
      // },
    ],
    series: [
      {
        name: "Tx",
        type: "bar",
        stack: "total",
        data: isCellular ? seriesData?.lte_tx : seriesData?.wan_tx,
      },
      {
        name: "Rx",
        type: "bar",
        stack: "total",
        data: isCellular ? seriesData?.lte_rx : seriesData?.wan_rx,
      },
    ],
    ...props,
    legend: {
      textStyle: {
        color: isDarkMode ? "white" : "black", // 新增深色模式時 報表字體顏色為 #white
      },
    },
  });

  const yAxisDbm = [
    {
      name: "dBm",
      max: Y2max || null,
    },
  ];
  // FIXME: 將RSSI 不顯示 === 0的資料
  const RSSIdata = seriesData?.lte_rssi.map((value) => (value === 0 ? undefined : value));
  // console.log("RSSIdata",RSSIdata)
  const signal = [
    {
      name: "RSSI",
      type: "line",
      yAxisIndex: 1,
      data: RSSIdata,
      // connectNulls：將缺失的數據視為連接的一部分 *(預設為false 關閉)*
      // connectNulls:true,
    },
    {
      name: "RSRP",
      type: "line",
      yAxisIndex: 1,
      data: seriesData?.lte_rsrp, //default = 0??
    },
  ];

  if (isCellular) {
    config.series = [...config.series, ...signal];
    config.toolbox.feature.magicType = {
      type: [],
      emphasis: {
        iconStyle: {
          color: "white",
        },
      },
    };
    config.yAxis = [...config.yAxis, ...yAxisDbm];
  }

  return (
    <Fragment>
      <ChartCard title={title} param={param} isFetching={isFetching}>
        <ReactECharts
          // echarts={echarts}
          option={config}
          style={{ height: "350px", width: "100%" }}
          notMerge={true}
          onEvents={{ click: (e: any) => console.log(e) }}
          // lazyUpdate={true}
          // theme={isDarkMode ? "dark" : "default"}
          // onChartReady={this.onChartReadyCallback}
          // onEvents={EventsDict}
          // opts={{ height: 800 }}
        />
      </ChartCard>
    </Fragment>
  );
};

export default UsageBarLine;
